import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {ApiService} from '../../services/api.service';
import {UserService} from '../../services/user.service';
import {HttpEvent, HttpResponse} from '@angular/common/http';
import {Group} from '../../models/group.model';
import { SortTableService } from '../../services/sort-table.service';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-my-groups',
  templateUrl: './my-groups.component.html',
  styleUrls: ['./my-groups.component.css']
})
export class MyGroupsComponent implements OnInit {
  public noGroupsInfo = true;
  public getGroupsErrorInfo = false;
  public isLoaded = false;
  public myGroupList;
  private mainGroup;
  user: User;
  flag = true;
  isAdmin = false;
  isHead = false;
  isUser = false;

  constructor(private apiService: ApiService,
              private userService: UserService,
              public sortTableService: SortTableService ) {
                this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
  }

  ngOnInit() {
    this.apiService.getMyGroups(this.userService.getLocal().id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.myGroupList = response.body;
          this.sortTableService.sortList('myGroupList', this.myGroupList, 'title');
          this.getGroupsErrorInfo = false;
          if (this.myGroupList.length > 0) {
            this.noGroupsInfo = false;
          } else {
            this.noGroupsInfo = true;
          }
        }
        if (response.status === 204) {
          this.getGroupsErrorInfo = false;
          this.noGroupsInfo = true;
        }
        this.isLoaded = true;
      },
      () => {
        this.noGroupsInfo = true;
        this.getGroupsErrorInfo = true;
        this.isLoaded = true;
      }
    );
    this.checkRole();
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
  }

  isSelectedGroup(name) {
      if(name.includes('*')) {
        return true
      } else {
        return false
      }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-groups/my-groups.component.ts